<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/3MiQJj/tc-custom/9781466846784.jpg?1728954333341" alt="This image is the cover for the book Immaculate Heart"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Immaculate Heart
      </h1>
      <p class="bookDescription body article font2">
        <p>When visiting Ballymorris in Ireland for a funeral, a down-on-his-luck  American reporter learns of a story that happened only months after his  last visit many years before.  A group of four teenagers, three of whom  are family friends, claimed to have been visited by the Virgin Mary.   Almost twenty years later, one of them denies it ever happened, another  has left the small town, never to be heard from again, another has  become a nun, and the fourth has been locked away in a psychiatric ward  for many years.  At the time, news of the visitation brought much wealth  and tourism to this dreary Irish town, but as the years went by, and  after the Pope refused to officially recognize it as a true Marian  Apparition, what had been seen as a miracle began to feel like a curse,  and this reporter believes there is more to the story than the  townspeople are letting on.<br/><br/>As he seeks out each of the four  stories, each begins to take a different and sinister turn.  Surrounded  by secrecy and confusion,  the journalist must decide how much of what  he's uncovering is the truth, how much of it is lies, and much he can  trust the four witnesses-one of whom he's become infatuated with-or for  that matter, himself. <br/><br/><i>Immaculate Heart</i> is a novel where  nothing is certain and everything should be questioned. Camille  DeAngelis will leave you guessing what is real and what is only just a  vision.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Camille DeAngelis
      </h2>
      
      <p class="authorDescription body article">Camille DeAngelis is the author of the novels <I>Bones & All, Mary Modern,</I><I>Petty Magic</I> and a first-edition guidebook, <I>Moon Ireland</I>. A graduate of NYU and the National University of Ireland, Galway, Camille currently lives in Boston. She is a vegan.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      St. Martin’s Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?5daf79e0